/**
 * Created by idea on 27/03/2017.
 */
import {Component, Input} from '@angular/core';
import {Owner} from '../models/Owner';
import {Http} from '@angular/http';

@Component({
    selector: 'ick-avatar',
    template: `<img (error)="img.src = temp_img" #img style="border-radius:50%; display:inline-block;" [src]="src ? (outside ? src :src+(size ? size : '_thumb_medium.jpg')) : temp_img" [alt]="alt ? alt : owner.social_name" [title]="title ? title : owner.social_name" [class]="class" [width]="width" [height]="height" />`
})

export class AvatarComponent {
    public temp_img = '/assets/images/avatar-placeholder.png';
    public outside = false;
    private _src : string;
    private _size : string;
    private _owner : Owner;

    @Input()
    set owner(value:Owner) {
        this._owner = value;
        if (value.avatar) {
            if (value.avatar.match(/^http/) || value.avatar.endsWith('.jpg')) {
                this._src = value.avatar;
                this.outside = true;
            } else {
                this._src = "http://ucontent.icheck.vn/" + value.avatar ;
            }
        }else{
            // if(value.social_type === 'facebook'){
            //     this._src = 'http://graph.facebook.com/'+value.social_id+'/picture';
            // }
            // this.outside = true;
        }
    }
    get owner(){
        return this._owner;
    }
    get src(){
        return this._src;
    }

    //size : small,medium,thumb_medium,thumb_medium,thumb_small,original
    @Input()
    set size(value:string) {
        if (value) {
            this._size = '_' + value + '.jpg';
        }else{
            this._size = '_thumb_medium.jpg'
        }
    }

    get size() {
        return this._size;
    }

    @Input()
        alt:string;

    @Input()
        title:string;

    @Input()
        class:string;

    @Input()
        width:number;

    @Input()
        height:number;

    constructor(private http:Http) {
    }
}


// WEBPACK FOOTER //
// /app/src/app/common/helper/avatar.component.ts